export default __webpack_public_path__ + "static/media/logo.857931b4.jpg";